import React, { memo } from 'react';
import { Text, CardContainer, AboveCard, Card, Header, LegalText, Promotion, } from './components';
import Container from '../../atoms/Container';
import { eventParamAttributes, } from '@spotify-internal/touchdown-analytics';
import { Type, TextLink } from '@spotify-internal/encore-web';
import { purify } from '../../utils/helpers';
export function SingleCard({ container, promotion, header, subheaders, legalDisclaimer, dataEventName, dataEventLabelLink, dataEventLabelLegal, supheader, link, cardBackgroundColor, aboveCardTextColor, eventParams, }) {
    const dataLinkEventProps = Object.assign(Object.assign({}, (dataEventName && { 'data-event-name': dataEventName })), (dataEventLabelLink && { 'data-event-label': dataEventLabelLink }));
    const dataLegalEventProps = Object.assign(Object.assign({}, (dataEventName && { 'data-event-name': dataEventName })), (dataEventLabelLegal && { 'data-event-label': dataEventLabelLegal }));
    return (React.createElement(Container, Object.assign({}, container, eventParamAttributes(eventParams)),
        React.createElement(CardContainer, null,
            (supheader || link) && (React.createElement(AboveCard, { color: aboveCardTextColor },
                supheader && (React.createElement(Text, { variant: "body1", dangerouslySetInnerHTML: {
                        __html: purify(supheader),
                    } })),
                link && (React.createElement(TextLink, Object.assign({ href: link.url, onClick: link.onClick }, dataLinkEventProps), link.text)))),
            React.createElement(Card, { background: cardBackgroundColor, color: aboveCardTextColor },
                promotion && React.createElement(Promotion, { weight: Type.black }, promotion),
                header && (React.createElement(Header, { variant: "heading3", dangerouslySetInnerHTML: {
                        __html: purify(header),
                    } })),
                subheaders &&
                    subheaders.map((subheader, x) => {
                        return (React.createElement(Text, { variant: "heading4", key: x, dangerouslySetInnerHTML: {
                                __html: purify(subheader),
                            } }));
                    }),
                legalDisclaimer && (React.createElement(LegalText, Object.assign({ variant: "body3", dangerouslySetInnerHTML: {
                        __html: purify(legalDisclaimer),
                    } }, dataLegalEventProps)))))));
}
export default memo(SingleCard);
//# sourceMappingURL=single-card.js.map